import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../reducers';
import styles from '../entity-region-page.module.scss';
import EntityInfo from '../../components/entity-info';
import {
  setComparedEntity,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { dataCategories } from '../../helpers/formatters';
import scrollToComponent from '../../helpers/scroll-to-component';
import { PortInfoGrid } from '../../components/region-entity-table/port-info-grid';
import DataCard from '../../components/data-card';
import DataCubeRow from '../../components/data-cube-row';

class EntityPage extends Component {
  constructor() {
    super();
    this.cardElements = {};
    this.selectRegion = this.selectRegion.bind(this);
    this.selectComparedRegion = this.selectComparedRegion.bind(this);
    this.goToSearch = this.goToSearch.bind(this);
    this.goToCompare = this.goToCompare.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.renderEntityCards = this.renderEntityCards.bind(this);
  }

  scrollTo(card) {
    const element = this.cardElements[card];
    scrollToComponent(element);
  }

  goToSearch() {
    const { setActivePage, setActiveEntity, setComparedEntity } = this.props;
    setActivePage('search');
    setActiveEntity(null);
    setComparedEntity(null);
  }

  goToCompare() {
    const { setActivePage } = this.props;
    setActivePage('compareSelectEntities');
  }

  selectRegion(regionId) {
    const { setActiveRegion } = this.props;
    setActiveRegion(regionId);
  }

  selectComparedRegion(regionId) {
    const { setComparedRegion } = this.props;
    setComparedRegion(regionId);
  }

  renderEntityCards() {
    const { activeEntity, comparedEntity, comparing } = this.props;

    return (
      <div
        className={
          comparing
            ? `${styles.mapsRow} ${styles.comparedEntitiesRow}`
            : styles.mapsRow
        }
        data-comparing={comparing}
      >
        <EntityInfo
          entity={activeEntity}
          comparing={comparing}
          key={comparing ? 0 : 1}
          comparisonId={comparing ? comparedEntity.id : null}
        />
        {comparing && (
          <EntityInfo
            entity={comparedEntity}
            comparing={comparing}
            key={2}
            isComparisonCouncil={true}
          />
        )}
      </div>
    );
  }

  renderDataCards() {
    return dataCategories.map((card) => {
      return (
        <DataCard
          key={card.id}
          ref={(el) => (this.cardElements[card.id] = el)}
          id={card.id}
          color={card.color}
          label={card.label}
        />
      );
    });
  }

  render() {
    const { activeEntity, comparedEntity, comparing } = this.props;

    const comparingPorts =
      comparing && activeEntity.isPort && comparedEntity.isPort;
    const singlePort = !comparing && activeEntity.isPort;

    return (
      <div className={styles.councilPage}>
        <div className={styles.buttonsRow}>
          <button
            type="button"
            className={styles.backLink}
            onClick={this.goToSearch}
          >
            <img
              className={styles.backLinkImage}
              src={`${process.env.PUBLIC_URL}/img/chevron-icon.svg`}
              alt="chevron icon"
              style={{ width: 10, height: 10 }}
            />
            back to search
          </button>
          {activeEntity.compare && (
            <button
              className={styles.compareButton}
              onClick={() => this.goToCompare()}
            >
              Compare with another entity
            </button>
          )}
        </div>
        {this.renderEntityCards()}
        {comparingPorts && (
          <div
            style={{ width: '100%', maxWidth: 900, margin: '0 auto 30px auto' }}
          >
            <PortInfoGrid entity={activeEntity} comparing={true} />
            <PortInfoGrid entity={comparedEntity} comparing={true} />
          </div>
        )}
        {singlePort && (
          <div
            style={{ width: '100%', maxWidth: 900, margin: '0 auto 30px auto' }}
          >
            <PortInfoGrid entity={activeEntity} comparing={false} />
          </div>
        )}
        <DataCubeRow
          activeEntity={activeEntity}
          comparedEntity={comparedEntity}
          onCubeClick={this.scrollTo}
        />
        {this.renderDataCards(activeEntity)}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setActiveEntity,
  setComparedEntity,
  setActivePage,
};

const mapStateToProps = (state) => ({
  activeEntity: selectors.getActiveEntity(state),
  comparedEntity: selectors.getComparedEntity(state),
  comparing: selectors.getComparedEntity(state) !== null,
  councils: selectors.getCouncils(state),
});

EntityPage.propTypes = {
  councils: PropTypes.arrayOf(PropTypes.object),
  setActiveEntity: PropTypes.func,
  setComparedEntity: PropTypes.func,
  activeEntity: PropTypes.object.isRequired,
  comparedEntity: PropTypes.object,
  setActivePage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityPage);



// WEBPACK FOOTER //
// ./src/pages/entity-page/entity-page.js